module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-winter-2600.3b4ce112.svg";